import { MessagePathPart } from "@/shared/domain/topics/MessagePathRecord";
import { MessagePayload } from "@/shared/webworker";

export enum DataServerCommand {
  GetAllData = "get-all-data",
  Init = "init",
}

export enum DataServerCommandResponse {
  GetAllDataResponse = "get-all-data-response",
  InitResponse = "init-response",
}

export type TopicIdToMessagePathValues = Record<
  string,
  { logtimes: bigint[]; values: Record<string, number[]> }
>;

export type TopicIdToMessagePaths = Record<
  string,
  Record<string, { id: string; parts: MessagePathPart[] }>
>;

export interface DataServerCommandPayloadMap {
  [DataServerCommand.GetAllData]: TopicIdToMessagePaths;
  [DataServerCommand.Init]: undefined;
}

export interface DataServerCommandResponsePayloadMap {
  [DataServerCommandResponse.GetAllDataResponse]: TopicIdToMessagePathValues;
  [DataServerCommandResponse.InitResponse]: undefined;
}

export function isDataServerInitCommand(
  event: MessageEvent<MessagePayload>,
): event is MessageEvent<
  MessagePayload<
    DataServerCommand,
    DataServerCommandPayloadMap[DataServerCommand.Init]
  >
> {
  return event.data.type === DataServerCommand.Init;
}

export function isDataServerGetAllDataCommand(
  event: MessageEvent<MessagePayload>,
): event is MessageEvent<
  MessagePayload<
    DataServerCommand,
    DataServerCommandPayloadMap[DataServerCommand.GetAllData]
  >
> {
  return event.data.type === DataServerCommand.GetAllData;
}
